import { z } from 'zod';
import {
  InstructionCategorySchema,
  TestingInstructionApplyModeSchema,
  TestingInstructionPipelineSchema,
} from '@terra/shared-schemas-orchestrator';

export const TestingInstructionFormSchema = z
  .object({
    title: z.string().trim().min(1),
    content: z.string().trim().min(1),
    applyMode: TestingInstructionApplyModeSchema,
    pipelines: z.array(TestingInstructionPipelineSchema),
    endpointGlobs: z.array(z.string()),
    description: z.string().nullable(),
    category: InstructionCategorySchema.nullable(),
  })
  .superRefine((values, context) => {
    if (values.applyMode === 'AUTO_ATTACHED') {
      const hasGlob = values.endpointGlobs.some(
        (glob) => glob.trim().length > 0,
      );

      if (!hasGlob) {
        context.addIssue({
          code: 'custom',
          path: ['endpointGlobs'],
          message:
            'At least one endpoint glob is required for auto-attached mode',
        });
      }
    }

    if (values.applyMode === 'AGENT_REQUESTED') {
      if (!values.description?.trim()) {
        context.addIssue({
          code: 'custom',
          path: ['description'],
          message: 'Description is required for agent-requested mode',
        });
      }
    }
  });

export type TestingInstructionFormValues = z.infer<
  typeof TestingInstructionFormSchema
>;
